import React, { createContext, useState, useEffect } from "react";
import { connect } from "react-redux";
import TargetTypeDropdown from "./TargetTypeDropdown";
import TargetTypeCheckboxSection from "./TargetTypeCheckboxSection";
import TargetTypeRadiobuttonSection from "./TargetTypeRadiobuttonSection";
import SearchInputV2 from "../../../view/SearchInputV2";
import { canEditRuleFields } from "../rulePermissions";


export const TargetTypes = {
    DEVICE_TYPE: "Device Type",
    LOCATION: "Location",
    COMPLIANCE: "Compliance",
    SECTORS: "Sectors",
    MSB: "MSB",
    GROUPS: "Groups"
}

export const TargetTypeContext = createContext(TargetTypes.DEVICE_TYPE);

// Returns a dynamic search placeholder based on the selected target type
function getSearchPlaceholder(targetType) {
    switch (targetType) {
        case TargetTypes.DEVICE_TYPE: return "Search device types...";
        case TargetTypes.MSB: return "Search MSBs...";
        case TargetTypes.LOCATION: return "Search locations...";
        case TargetTypes.COMPLIANCE: return "Search compliance...";
        case TargetTypes.SECTORS: return "Search sectors...";
        case TargetTypes.GROUPS: return "Search groups...";
        default: return "Search...";
    }
}

function TargetTypeTab({ rule, lastRuleLoad, auth }) {

    const [targetType, setTargetType] = useState(TargetTypes.DEVICE_TYPE);
    const [searchTerm, setSearchTerm] = useState('');
    const disabled = rule.baseRule === true || !canEditRuleFields(auth);

    const handleSearch = (e) => setSearchTerm(e.target.value);

    // Reset search when target type changes
    useEffect(() => {
        setSearchTerm('');
    }, [targetType]);

    return (
        <TargetTypeContext.Provider value={{ targetType, setTargetType }}>

            {/* Target Type selector row — uses oct_select-v2 style */}
            <div className="addrules-target-type-row-v2">
                <TargetTypeDropdown />
            </div>

            {/* Search bar — placeholder changes with target type */}
            <SearchInputV2
                value={searchTerm}
                onChange={handleSearch}
                placeholder={getSearchPlaceholder(targetType)}
                className="m-0"
            />

            {/* Item grid — radio buttons for MSB/Device Type, checkboxes for the rest */}
            {targetType === 'MSB' || targetType === 'Device Type' ?
                <TargetTypeRadiobuttonSection
                    key={lastRuleLoad}
                    searchTerm={searchTerm}
                    disabled={disabled}
                /> :
                <TargetTypeCheckboxSection
                    key={lastRuleLoad}
                    searchTerm={searchTerm}
                    disabled={disabled}
                />
            }

        </TargetTypeContext.Provider>
    )

}

function mapStateToProps(state) {
    const addRulesPage = state.addRulesPage;
    const auth = state.auth;
    return {
        rule: addRulesPage.rule,
        lastRuleLoad: state.addRulesPage.lastRuleLoad,
        auth,
    }
}

export default connect(mapStateToProps)(TargetTypeTab);
